(ns rlws.iot-cloud.frontend.navigation
  (:require [clojure.string :as str]
            [potpuri.core :as potpuri]
            [re-frame.core :as rf]
            [reitit.coercion.spec :as rss]
            [reitit.frontend :as reitit]
            [reitit.frontend.controllers :as rfc]
            [reitit.frontend.easy :as rfe]
            [reitit.frontend.history :as rfh]
            [rlws.iot-cloud.frontend.authentication :as authn]
            [rlws.iot-cloud.frontend.common :as common]
            [rlws.iot-cloud.frontend.routes :as routes]
            [rlws.iot-cloud.frontend.config :as config]
            [vimsical.re-frame.cofx.inject :as inject]))

(defn id-route
  "Given a route key and map containing an namespaced id path param, returns a url
  string"
  ([key params]
   (id-route key params nil)) 
  ([key params query] 
   (rfe/href key (potpuri/map-vals common/id-key params) query)))

(rf/reg-fx
 :navigate!
 (fn [route]
   (apply rfe/push-state route)))

(rf/reg-event-fx
 :navigate
 (fn [_ [_ & route]]
   {:navigate! route}))

(rf/reg-event-fx
 ::navigated
 (rf/inject-cofx ::inject/sub [:rlws.iot-cloud.frontend.subscriptions/current-user])
 (fn [{:keys [db :rlws.iot-cloud.frontend.subscriptions/current-user]} [_ new-match]]
   (let [old-match (:current-route db)
         controllers (rfc/apply-controllers (:controllers old-match) new-match)
         {:keys [name no-auth permission-required] :as data} (:data new-match)]
     (merge
      {:db (cond-> db
             :always (dissoc :global-message)
             :always (assoc :current-route (assoc new-match :controllers controllers))
             (common/media-query [:max-width :medium]) (assoc :show-menu? false))}
      {:dispatch-n (concat (:dispatch-n data)
                           (cond
                             (and permission-required
                                  (not (contains? (set (:permissions current-user))
                                                  permission-required)))
                             [[:navigate config/home-route]]
                             (authn/is-authenticated? db)
                             (if (= :login name)
                               [[:navigate config/home-route]]
                               [[::authn/refresh-token]])

                             (not no-auth)
                             [[:logout]]))}
      (when-let [event (:dispatch data)]
        {:dispatch event})))))

(rf/reg-event-fx
 :visit!
 (fn [_ [_ url]]
   (set! js/window.location.href url)))

(defn on-navigate [new-match]
  (if new-match
    (rf/dispatch [::navigated new-match])
    (rf/dispatch [:navigate config/home-route])))

(defn route->url
  "k: page handler i.e. :entity
  params: path-params map
  query: query-params map"
  ([k]
   (route->url k nil nil))
  ([k params]
   (route->url k params nil))
  ([k params query]
   (rfe/href k params query)))

(def router
  (reitit/router routes/routes {:data {:coercion rss/coercion}}))

(defn url->route
  "url: abosolute string path"
  [url]
  (reitit/match-by-path router url))

(defn url->route-key
  "url: abosolute string path"
  [url]
  (get-in (url->route url) [:data :name]))

(defn fragment-uri-on-current-page?
  [^goog.Uri uri]
  (and (not (str/blank? (.-fragment_ uri)))
       (= (.. js/window -location -pathname)
          (.-path_ uri))))

(defn init-routes! []
  (js/console.log "Initializing routes")
  (rfe/start!
   router
   on-navigate
   {:use-fragment false
    :ignore-anchor-click? (fn [router e el uri]
                            (and (rfh/ignore-anchor-click? router e el uri)
                                 (not (fragment-uri-on-current-page? uri))))}))
